__webpack_require__.p = "/wp-content/themes/code3/dist/js/";